import type {FlexSuiteHeroProps} from './types'
import {FlexSuiteHeroDefault} from './FlexSuiteHeroDefault'
import {FlexSuiteHeroStacked} from './FlexSuiteHeroStacked'
import {FlexSuiteHeroCarousel} from './FlexSuiteHeroCarousel'
import {FlexSuiteHeroIconCards} from './FlexSuiteHeroIconCards'
import {FlexSuiteHeroImageCards} from './FlexSuiteHeroImageCards'

export function FlexSuiteHero(props: FlexSuiteHeroProps) {
  const {heroVariant} = props

  switch (heroVariant) {
    case 'Stacked':
      return <FlexSuiteHeroStacked fields={props} />
    case 'Carousel':
      return <FlexSuiteHeroCarousel fields={props} />
    case 'Icon Cards':
      return <FlexSuiteHeroIconCards fields={props} />
    case 'Image Cards':
      return <FlexSuiteHeroImageCards fields={props} />
    default:
      return <FlexSuiteHeroDefault fields={props} />
  }
}
